export enum localStorageKeyOption {
    authToken = 'authToken',
    authExpiry = 'authExpiry',
    apiToken = 'apiToken'
}